import { useEffect, useRef, useState } from 'react';
import { IdentityAssignmentView } from './types';

export function useActiveAssignmentTab(views: IdentityAssignmentView[]) {
  const [activeId, setActiveId] = useState(views[0]?.id ?? '');
  const previousIds = useRef<string[]>([]);

  useEffect(() => {
    const ids = views.map(view => view.id);
    const previous = previousIds.current;
    const addedIds = ids.filter(id => !previous.includes(id));

    setActiveId(current => {
      if (ids.length === 0) return '';
      if (previous.length > 0 && addedIds.length > 0)
        return addedIds[addedIds.length - 1] ?? current;
      if (!ids.includes(current)) return ids[0] ?? '';
      return current;
    });

    previousIds.current = ids;
  }, [views]);

  return { activeId, setActiveId };
}
